export function buildOrderedTree (steps) {
  const childMap = {}
  const roots = []

  steps.forEach(s => {
    const pid = s.parentStepId ?? '__root__'
    if (!childMap[pid]) childMap[pid] = []
    childMap[pid].push(s)
  })

  const rootCandidates = childMap.__root__ || []
  if (rootCandidates.length > 0) {
    roots.push(...rootCandidates)
  } else if (steps.length > 0) {
    const parentIds = new Set(steps.map(s => s.parentStepId).filter(Boolean))
    const orphanRoot = steps.find(s => !parentIds.has(s.dagStepId)) || steps[0]
    roots.push(orphanRoot)
  }

  const result = []
  const visited = new Set()

  function walk (step, prefix, seqCounter) {
    if (visited.has(step.dagStepId)) return
    visited.add(step.dagStepId)
    result.push({ step, outline: prefix })
    const children = childMap[step.dagStepId] || []
    if (children.length === 1) {
      walk(children[0], String(seqCounter + 1), seqCounter + 1)
    } else {
      children.forEach((child, i) => {
        walk(child, `${prefix}.${i + 1}`, 0)
      })
    }
  }

  roots.forEach((root, i) => {
    walk(root, String(i + 1), i + 1)
  })

  steps.forEach(s => {
    if (!visited.has(s.dagStepId)) {
      result.push({ step: s, outline: '?' })
    }
  })

  return result
}
